export default {"src":"/_next/static/media/watch-flawless.3da4f780.svg","height":79,"width":25};